angular.module("SupportAgent")
.controller(
 'SupportTabsController',
 ['$rootScope', '$scope', 'EventHandler',
  'L','IDA',
 function ($rootScope, $scope, EventHandler,
           L,IDA) {
  this.TAB_DIAGNOSTICS = 1;
  this.TAB_SECURITY    = 2;
  this.TAB_REMOTE      = 4;
  this.TAB_APPS        = 5;
  this.TAB_DEVICE      = 7;
  this.TAB_MDM         = 8;
  this.TAB_CIRCLE      = 9;
  this.TAB_IDA_HOST    = 10;
  this.TAB_LOCATE_DEVICE = 11;
  this.TAB_SPEED_TEST = 12;
  this.tab = $rootScope.hidden_features.deviceinfo?this.TAB_CIRCLE:this.TAB_DEVICE;
  var that = this;
  $rootScope.support_tabs_loaded = true;
  this.selectTab = function (setTab) {
   this.tab = setTab;
   switch(setTab) {
    case this.TAB_REMOTE:
     if(($rootScope.remoteConnection.acid==$rootScope.accountID)&&
      ($rootScope.remoteConnection.did== $rootScope.deviceID)&&
      ($rootScope.remoteConnection.connected)) $rootScope.conStatus = true;
     else $rootScope.conStatus = false; 
    break;
    case this.TAB_APPS:
     $rootScope.updateAppsList();
    break;
    case this.TAB_MDM:
     $rootScope.$broadcast("fetchMDMInfo", "results");
    break;
    case this.TAB_IDA_HOST:
     /* TODO: we should probably login on demand if we lack ida session here or
      * possibly hide the tab altogether if we have problems with ida */
     var elm=parent.document.getElementById("mainframe");
     var IDA_URL = IDA.get_url('user-tab',{acid:$rootScope.selected_account.id});
     L.trace("Navigating to IDA url " + IDA_URL);
     elm.src =IDA_URL;
    break;
    case this.TAB_SPEED_TEST:
     $rootScope.initSpeedtestModule($rootScope.speedtest_capabilities);
     break;
    default:
    break;
   }
  };
  this.isSelected = function (checkTab) {
   return this.tab === checkTab;
  };
  $rootScope.setDefaultTab = function() {
    that.selectTab($rootScope.hidden_features.deviceinfo?that.TAB_CIRCLE:that.TAB_DEVICE);
  };
 }]);
